import util from 'util'
import socketCluster from 'socketcluster-client'
import PlayStore from '@/stores/PlayStore'
import GameEventStore from '@/stores/GameEventStore'
import config from '@/Agent/config'

let socket = null
let currentManagedGame = {}
let currentManagedGameInfo = {}
let isDatabaseResettingFromLocal = false

const connectOptions = config.connectOptions

//------------------------------------------------------------------------
const debug = obj => {
  return console.log(util.inspect(obj, { depth: null }))
}

//------------------------------------------------------------------------
const channelWatch = async (channel, processor) => {
  for await (let data of channel) {
    processor(data)
  }
}

const socketReceiver = async (socket, event, func) => {
  for await (let data of socket.receiver(event)) {
    func(data)
  }
}
const connect = () => {
  if (socket == null) {
    socket = socketCluster.create(connectOptions)
    handleConnect()

    /*
    socket.on('subscribeFail', function(channelname) {
      console.log(
        '[Server Socket] Failed to Subscribe to Channel:' + channelname
      )
    })

    socket.on('connect', status => {
      console.log('Game Server is connected')
      // Add code here to check if authenticated
      if (status.isAuthenticated) {
        console.log('connection status:')
        debug(status)
      } else {
        console.log('client not authenticated:')
        debug(status)
      }

      let gameStageChannel = socket.subscribe('admin.game.update')
      gameStageChannel.watch(params => {
        GameEventStore.setUpdatedGame(params)
      })

    })

    socket.on('close', _ => {
      console.log(`[Server Socket] Socket has closed`)
      // if (currentManagedGame['hostGameChannel']) {
      //   //currentManagedGame['hostGameChannel'].unwatch(hostGameChannelWatcher)
      //   socket.destroyChannel(currentManagedGame['hostGameChannel'].name)
      // }
    }) */
  }
}

const handleConnect = async () => {
  await socket.listener('connect').once()

  socketReceiver(socket, 'user.login.respond', () => {
    let gameStageChannel = socket.subscribe('admin.game.update')
    handleAdminGameUpdate(gameStageChannel)
  })
}

const handleAdminGameUpdate = async gameStageChannel => {
  for await (let params of gameStageChannel) {
    GameEventStore.setUpdatedGame(params)
  }
}

export function send(channel, data, opts) {
  if (!opts) opts = {}
  return new Promise((resolve, reject) => {
    connect()
    console.log(`[Server Send : ${channel}]`)

    const _data = {
      event: channel,
      data: data,
    }
    connect()
    if (opts.transmit) {
      socket.transmit('i', _data)
      console.log(['socket.transmit', _data]) //tmp to delete
      return resolve(null)
    }
    socket.invoke('i', _data).then((response, err) => {
      console.log(['socket.invoke', _data]) //tmp to delete
      if (err) {
        PlayStore.showErrorPage(err)
      }
      if (response) {
        if (response.success) {
          return resolve(response.response)
        } else {
          return reject(response)
        }
      }
    })
  })
}

export const getBrandappBrandIds = args => {
  //args.sportTypeCode
  //args.location
  return send('app.read.brandapp.brand.ids', args)
}

export const getBrandapp = args => {
  //args.gameId
  return send('app.read.brandapp', args)
}

export const getBrandappConfig = () => {
  return send('app.read.brandapp.config', null)
}

export const getBrands = () => {
  return send('user.read.brands', null)
}

export const readGameMasters = () => {
  return send('host.read.game.masters')
}

export const readCelebrities = () => {
  return send('host.read.celebrities')
}

export const broadcastPlay = type => {
  return send('games.changeplay', type, { transmit: true })
}

export const broadcastLockout = val => {
  return send('games.lockplay', val, { transmit: true })
}

export const endPlay = val => {
  return send('games.endplay', val, { transmit: true })
}

export const changeNextPlay = val => {
  return send('games.changenextplay', val, { transmit: true })
}

export const showResult = val => {
  return send('games.result', val)
}

export const broadcastResolvePending = val => {
  return send('games.resolve', val, { transmit: true })
}

export const announcement = val => {
  return send('games.announcement', val, { transmit: true })
}

export const typeList = () => {
  return send('games.typelist', {})
}

export const activeGame = args => {
  return send('games.active', args)
}

export const gamesInfo = args => {
  return send('games.info', args)
}

export const authenticate = args => {
  return send('authentication', args)
}

export const gamesCreate = args => {
  let testGame
  return send('games.create', args)
    .then(response => {
      console.log('initially created game', response.item.id)
      return send('games.pending', { progress: 'Pending' })
    })
    .then(games => {
      testGame = games[0]
      console.log(`pending games ${games.map(g => g.id)}`)
      return send('games.info', [testGame.id])
    })
    .then(gamesInfo => {
      testGame.playStack = gamesInfo[0].playStack
      return send('games.update', { entityType: 'Game', value: testGame })
    })
    .then(updateResponse => {
      return (testGame = updateResponse.item)
    })
    .catch(err => {
      console.log(`error in setting up the database ${err}`)
    })
}

export const gamesPending = args => {
  return send('games.pending', args)
}

export const gamesUpdate = args => {
  return send('games.update', args)
}

export const gamesUpdatePreset = args => {
  currentManagedGame['hostGameChannel'].transmitPublish({
    event: 'games.removeplayfromstack',
    data: { playId: args.playId },
  })
}

export const removePlayFromStack = playId => {
  currentManagedGame['hostGameChannel'].transmitPublish({
    event: 'games.removeplayfromstack',
    data: { playId: playId },
  })
}

export const gamesRead = args => {
  return send('games.read', args)
}

export const addThePlay = play => {
  connect()
  currentManagedGame['hostGameChannel'].transmitPublish({
    event: 'games.addplaytostack',
    data: { play: play },
  })
}

export const gamesGoPlay = playToGo => {
  connect()
  currentManagedGame['hostGameChannel'].transmitPublish({
    event: 'games.goplay',
    data: { play: playToGo },
  })
}

export const gamesStart = () => {
  connect()
  currentManagedGame['hostGameChannel'].transmitPublish(
    { event: 'games.start' },
    err => {
      if (err) {
        console.log('game start failed', err)
      }
    }
  )
}

export const gamesStartPlay = playId => {
  connect()
  currentManagedGame['hostGameChannel'].transmitPublish({
    event: 'games.startplay',
    data: { playId: playId },
  })
}

export const gamesLockPlay = playId => {
  connect()
  currentManagedGame['hostGameChannel'].transmitPublish({
    event: 'games.lockplay',
    data: { playId: playId },
  })
}

export const gamesEndPlay = args => {
  connect()
  currentManagedGame['hostGameChannel'].transmitPublish({
    event: 'games.endplay',
    data: { playId: args.playId, result: args.result },
  })
}

export const gamesConfirmPlay = playId => {
  connect()
  currentManagedGame['hostGameChannel'].transmitPublish({
    event: 'games.confirmplay',
    data: { playId: playId },
  })
}

export const gamesEndGame = () => {
  connect()
  currentManagedGame['hostGameChannel'].transmitPublish(
    { event: 'games.endgame' },
    err => {
      if (err) {
        console.log('game end failed', err)
      } else {
        console.log('game successfully ended')
      }
    }
  )
}

export const movePlayBefore = args => {
  connect()
  currentManagedGame['hostGameChannel'].transmitPublish({
    event: 'games.moveplaybefore',
    data: { playId: args.playId, beforeId: args.beforeId },
  })
}

export const manageGame = game => {
  return new Promise(resolve => {
    connect()
    currentManagedGame = game
    if (!socket.isSubscribed(game.id + '.host')) {
      currentManagedGame['hostGameChannel'] = socket.subscribe(
        game.id + '.host'
      )
      establishHostWatchers()
    }
    resolve(currentManagedGame['hostGameChannel'])
  })
}

const establishHostWatchers = () => {
  //hostGameChannel.watch(data => {
  channelWatch(currentManagedGame['hostGameChannel'], data => {
    switch (data.event) {
      case 'plays.stackupdate':
        console.log('PLAYS.STACKUPDATE', data.data)
        PlayStore.updatePlayStack({
          playStack: data.data.playStack,
          plays: data.data.plays,
        })
        break
      case 'games.update':
        const updatedGame = Object.assign(currentManagedGameInfo, data.data)
        console.log('GAMES.UPDATE', updatedGame)
        //PlayStore.updateGameX1(updatedGame)
        PlayStore.setGame(data.data)
        break
      case 'games.startplay':
        console.log('GAMES.STARTPLAY', PlayStore.game.id, data)
        //PlayStore.updateGame()
        PlayStore.gamesStartPlayNull(data.data)
        break
      case 'games.endplay':
        console.log('GAMES.ENDPLAY', data.data)
        PlayStore.gamesEndPlayResult(data.data)
        break
      case 'plays.update':
        console.log('PLAYS.UPDATE', data.data)
        PlayStore.playUpdate(data.data)
        break
      case 'games.endgame':
        console.log('GAMES.ENDGAME')
        PlayStore.gamesEndGameWatch()
        break
      default:
        if (
          [
            'games.prepickstart',
            'games.ready',
            'games.start',
            'games.endplay',
            'games.addplaytostack',
            'games.removeplayfromstack',
            'games.goplay',
            'games.lockplay',
            'games.confirmplay',
            'games.moveplaybefore',
          ].indexOf(data.event) < 0
        ) {
          // missing implementation
          console.log('unimplemented event', data)
        }
    }
  })

  console.log('SUBSCRIBED', currentManagedGame['hostGameChannel'])
}

export const connectSC = () => {
  connect()
}



// WEBPACK FOOTER //
// src/Agent/GameServer.js